import React, { Component } from 'react'
import TakeawayOrderSummary from '../../containers/components/TakeawayOrderSummary'
import TakeawayPaymentSummary from '../../containers/components/TakeawayPaymentSummary'
import helpers from 'helpers'
import styles from '../../assets/styles/components/TakeawaySummary'
import injectSheet from 'react-jss'
import moment from 'moment'
import * as _ from 'lodash'
import { DELIVERY_TYPE_TAKEAWAY, FIRST_DATA_MERCHANTS, DELIVERY_TYPE_STOREDELIVERY } from '../../constants/merchant'
import { PAYMENT_GATEWAY_STRIPE, PAYMENT_GATEWAY_FIRST_DATA } from '../../constants/app'
import cx from 'classnames'
import orderApi from 'services/api/order'
import { Icon, Button } from 'antd-mobile'
import { getStorage, setStorage, loadState } from '../../store/localStorage'

class TakeawaySummary extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isPayment: false,
      pickupAt: props.form.datetime || '',
      dropoffat: this.getDeliveryTimeslot()[0].format(),
      tel: props.user.tel || '',
      promoCode: '',
      recentPaymentInfo: null,
      shouldShowApplePayBtn: false,
      shouldShowGooglePayBtn: false,
      name: props.user.name || '',
      deliveryType: '',
      selectedTimeslot: false,
      needTableware: props.user.needTableware || true,
      deliveryAddress: '',
      deliveryAddressName: '',
      lat: props.user.lat || null,
      lng: props.user.lng || null,
      address: props.user.address || '',
      floorRoom: props.user.floorRoom || '',
      companyBuilding: props.user.companyBuilding || '',
      district: props.user.district || '',
      paymentGateway: '',
      wechatRedirect: false,
      wechatLoading: false,
    }
    window._submittingOrder = false
  }

	componentDidMount = async () => {
	  const { stripe, basket, setTakeawayWaitingBasket } = this.props

	  if (basket) {
	    if (basket.isDelivery && basket.isDeliveryAvailable) {
	      this.setState({ deliveryType: 'delivery' })
	    } else if (basket.isShop) {
	      this.setState({ deliveryType: 'shop' })
	    } else if (basket.isStoreDelivery) {
	      this.setState({ deliveryType: 'storeDelivery' })
	    } else if (basket.isTakeaway) {
	      this.setState({ deliveryType: 'takeaway' })
	    }
	  }

	  const paymentRequest = stripe.paymentRequest({
	    country: 'HK',
	    currency: 'hkd',
	    total: {
	      label: '外賣自取',
	      amount: 1,
	    },
	    requestPayerName: false,
	    requestPayerEmail: false,
	  })

	  paymentRequest
	    .canMakePayment()
	    .then((result) => {
	      if (result && result.applePay) {
	        this.setState({
	          paymentRequest: paymentRequest,
	          shouldShowApplePayBtn: true,
	        })
	      } else if (result) {
	        this.setState({
	          paymentRequest: paymentRequest,
	          shouldShowGooglePayBtn: true,
	        })
	      }
	    })
	    .catch((err) => {
	      console.error('paymentRequest cannot MakePayment', err)
	    })
	  const wc_payload = getStorage('wc_payload')
	  // console.log('wc_payload on TakewaySummary', wc_payload);

	  if (!_.isEmpty(wc_payload)) {
	    // console.log('localCache on TakewaySummary', loadState());
	    this.setState({
	      isPayment: true,
	      wechatRedirect: true,
	    })
	    // this.setState({ wechatLoading: true });
	    // setTimeout(() => {
	    //   console.log('hi')
	    // 		window._submittingOrder = true;
	    // 		this.getWechatOrderStatus();
	    // }, 5000);
	  } else {
	    setTakeawayWaitingBasket({})
	  }
	}

	componentDidUpdate = async (prevProps) => {
	  const { merchant, getRecentPaymentInfo } = this.props

	  if (_.get(merchant, 'id') && !this.state.paymentGateway) {
	    let paymentGateway = process.env.REACT_APP_PAYMENT_GATEWAY
	    if (FIRST_DATA_MERCHANTS.includes(this.props.merchant.id)) {
	      paymentGateway = PAYMENT_GATEWAY_FIRST_DATA
	    } else {
	      paymentGateway = PAYMENT_GATEWAY_STRIPE
	    }
	    this.setState({ paymentGateway })

	    try {
	      const recentPaymentInfo = await getRecentPaymentInfo().then((payments) => {
	        return payments.filter((p) => p.gateway === paymentGateway)[0]
	      })
	      this.setState({
	        recentPaymentInfo,
	      })
	    } catch (err) {
	      console.error('CANNOT find any recent payment')
	    }
	  }
	}

	handleSubmitBtnClick = () => {
	  const {
	    tel,
	    name,
	    needTableware,
	    deliveryAddress,
	    address,
	    floorRoom,
	    companyBuilding,
	    district,
	    lat,
	    lng,
	  } = this.state

	  this.setState({ isPayment: true })

	  this.props.updateTel(tel)
	  this.props.updateName(name)
	  this.props.updateNeedTableware(needTableware)
	  deliveryAddress && this.props.updateDeliveryAddress(deliveryAddress)
	  this.props.updateAddress(address)
	  this.props.updateFloorRoom(floorRoom)
	  this.props.updateCompanyBuilding(companyBuilding)
	  this.props.updateDistrict(district)
	  this.props.updateLat(lat)
	  this.props.updateLng(lng)
	}

	handleCloseBtnClick = () => {
	  this.setState({
	    isPayment: false,
	  })
	}

	updateParentState = (obj) => {
	  this.setState(obj)
	}

	getDeliveryTimeslot = () => {
	  const slots = ['12:30', '13:00', '13:30', '14:00']

	  return slots.map((o) => {
	    const m = moment().set({
	      hour: o.split(':')[0],
	      minute: o.split(':')[1],
	      second: 0,
	    })
	    if (m < moment()) {
	      m.add(1, 'day')
	    }
	    return m
	  })
	}

	getWechatOrderStatus = async () => {
	  const { out_trade_no, syssn } = getStorage('wc_payload')
	  if (!out_trade_no) {
	    return
	  }
	  this.setState({ wechatLoading: true })
	  await orderApi.getWechatOrderStatus(out_trade_no).then((res) => {
	    //  TODO: how to define success response
	    if (res.respcd === '0000') {
	      this.takeawayPaymentSummary.submit({
	        payment: 'wechatpay',
	        source: out_trade_no,
	        out_trade_no: out_trade_no,
	        syssn: syssn,
	      })
	    }
	  })
	  this.setState({ wechatLoading: false })
	}

	renderWeChatPayModal = () => {
	  const { classes, intl } = this.props
	  return (
	    <div className={cx(classes['wechat-pay-modal'])}>
	      <div className={cx(classes['wechat-pay-dialog'])}>
	        {this.state.wechatLoading ? (
	          <div className={cx(classes['wechat-pay-title'])}>
	            <Icon type="loading" />
	            <p>{intl.formatMessage({ id: 'wechatConfirmation.loading' })}</p>
	          </div>
	        ) : (
	          <div>
	            <div className={cx(classes['wechat-pay-title'])}>
	              {intl.formatMessage({ id: 'wechatConfirmation.message' })}
	            </div>

	            <Button
	              className={cx(classes['wechat-paid-btn'])}
	              type="primary"
	              onClick={() => {
	                this.getWechatOrderStatus()
	              }}
	            >
	              {intl.formatMessage({ id: 'wechatConfirmation.paid' })}
	            </Button>
	            <Button
	              onClick={() => {
	                this.setState({ wechatRedirect: false })
	                setStorage('wc_payload', {})
	              }}
	            >
	              {intl.formatMessage({ id: 'wechatConfirmation.error' })}
	            </Button>
	          </div>
	        )}
	      </div>
	    </div>
	  )
	}

	render () {
	  const {
	    takeawayOrders,
	    merchant,
	    // classes,
	    discount,
	    basket,
	  } = this.props

	  const {
	    deliveryType,
	    shouldShowApplePayBtn,
	    shouldShowGooglePayBtn,
	    recentPaymentInfo,
	    pickupAt,
	    tel,
	    name,
	    promoCode,
	    dropoffat,
	    needTableware,
	    address,
	    floorRoom,
	    companyBuilding,
	  } = this.state

	  if (this.state.isPayment) {
	    const WrappedPaymentSummary = () => {
	      let total =
					helpers.calculate.calculateOptionsTotal(takeawayOrders) +
					helpers.calculate.calculateDishsTotal(takeawayOrders)
	      if (discount && discount.percent > 0) {
	        total = total * (100 - discount.percent) / 100
	      } else if (discount && discount.amount > 0) {
	        total = total - discount.amount
	      }
	      const shouldShowCashBtn =
					deliveryType === DELIVERY_TYPE_TAKEAWAY &&
					_.get(merchant, 'setting.takeawayCashPayment') &&
					!basket.isCardOnly

	      const shouldShowWeChatPayBtn = _.get(merchant, 'setting.enableWechatPay')
	      return (
	        <div>
	          {this.state.wechatRedirect && this.renderWeChatPayModal()}
	          <TakeawayPaymentSummary
	            childRef={(cd) => {
	              this.takeawayPaymentSummary = cd
	            }}
	            total={total}
	            pickupAt={pickupAt}
	            dropoffat={dropoffat}
	            deliveryType={deliveryType}
	            recentPaymentInfo={recentPaymentInfo}
	            deliveryAddress={this.state.deliveryAddress}
	            onCloseBtnClick={this.handleCloseBtnClick}
	            paymentGateway={this.state.paymentGateway}
	            shouldShowCashBtn={shouldShowCashBtn}
	            shouldShowApplePayBtn={shouldShowApplePayBtn}
	            shouldShowGooglePayBtn={shouldShowGooglePayBtn}
	          />
	        </div>
	      )
	    }
	    return <WrappedPaymentSummary />
	  } else {
	    return (
	      <TakeawayOrderSummary
	        basket={basket}
	        tel={tel}
	        promoCode={promoCode}
	        address={address}
	        floorRoom={floorRoom}
	        companyBuilding={companyBuilding}
	        deliveryAddress={this.state.deliveryAddress}
	        deliveryAddressName={this.state.deliveryAddressName}
	        name={name}
	        needTableware={needTableware}
	        dropoffat={dropoffat}
	        getDeliveryTimeslot={this.getDeliveryTimeslot}
	        pickupAt={pickupAt}
	        selectedTimeslot={this.state.selectedTimeslot}
	        deliveryType={deliveryType}
	        updateParentState={this.updateParentState}
	        onSubmitBtnClick={this.handleSubmitBtnClick}
	      />
	    )
	  }
	}
}

export default injectSheet(styles)(TakeawaySummary)



// WEBPACK FOOTER //
// ./src/components/scenes/TakeawaySummary.js